import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { PURPLE, FG_3, FONTS } from './theme.js';
import { ArrowIcon } from './ArrowIcon.jsx';

export function InternalLinksSection({ title, links, background = '#fff' }) {
    return (
        <Box component="nav" aria-label={title} sx={{ py: 6, background }}>
            <Container maxWidth="lg">
                <Typography
                    component="h2"
                    sx={{
                        fontFamily: FONTS.mono,
                        fontSize: '0.66rem',
                        fontWeight: 500,
                        letterSpacing: '0.08em',
                        textTransform: 'uppercase',
                        color: FG_3,
                        textAlign: 'center',
                        mb: 2,
                    }}
                >
                    {title}
                </Typography>
                <Stack
                    direction="row"
                    sx={{
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        gap: 1.25,
                    }}
                >
                    {links.map(({ label, href }) => (
                        <Box
                            key={href}
                            component="a"
                            href={href}
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 0.6,
                                fontSize: '0.84rem',
                                fontWeight: 600,
                                color: PURPLE,
                                background: '#fff',
                                border: '1px solid rgba(81,36,166,0.22)',
                                px: 2,
                                py: 1.1,
                                borderRadius: '8px',
                                textDecoration: 'none',
                                transition: 'background .15s',
                                '&:hover': { background: 'rgba(81,36,166,0.06)' },
                            }}
                        >
                            {label}
                            <ArrowIcon size={16} />
                        </Box>
                    ))}
                </Stack>
            </Container>
        </Box>
    );
}
